import { DefaultTheme } from 'styled-components';
import { OrderEvent } from '../../../../server-types';
import { TimelineEvent } from '../../../../types';
import { translate } from '../../../../utils';

export const defineMilestoneColor = (theme: DefaultTheme, state: OrderEvent) => {
    if (state === OrderEvent.Created) {
        return theme.palette.primary.main;
    }
    if (state === OrderEvent.PaidCompletely) {
        return theme.palette.primary.main;
    }
    if (state === OrderEvent.MovedCompletely) {
        return theme.palette.warning.main;
    }
    if (state === OrderEvent.CanceledCompletely) {
        return theme.palette.secondary.main;
    }
    return theme.palette.error.main;
};

export const defineDetailsColor = (theme: DefaultTheme, state: TimelineEvent['eventType']) => {
    if (state === OrderEvent.OrderLinesAdded) {
        return theme.palette.common.white;
    }
    if (state === OrderEvent.QuickSale) {
        return theme.palette.primary.main;
    }
    if (state === OrderEvent.CanceledCompletely) {
        return theme.palette.secondary.main;
    }
    if (state === OrderEvent.CanceledPartially) {
        return theme.palette.secondary.main;
    }
    if (state === OrderEvent.MovedCompletely) {
        return theme.palette.warning.main;
    }
    if (state === OrderEvent.PaidPartially) {
        return theme.palette.success.main;
    }
    return theme.palette.common.white;
};

export const stateToTextMap = {
    [OrderEvent.OrderLinesAdded]: translate('Added'),
    [OrderEvent.PaidCompletely]: translate('Order was closed by'), 
    [OrderEvent.CanceledPartially]: translate('Canceled'),
    [OrderEvent.MovedPartially]: translate('Order was moved'),
    [OrderEvent.MovedCompletely]: translate('Whole order was moved by'),
    [OrderEvent.CanceledCompletely]: translate('Whole order was canceled by'),
    [OrderEvent.QuickSale]: translate(''),
    [OrderEvent.Created]: translate(''),
    [OrderEvent.PaidPartially]: translate('Payment'),
};

export const milestoneStateToText = {
    [OrderEvent.Created]: translate('Order was opened by'),
    [OrderEvent.CanceledPartially]: translate('Order was closed by'),
    [OrderEvent.CanceledCompletely]: translate('Order was cancelled by'),
    [OrderEvent.MovedCompletely]: translate('Whole order was moved by'),
    [OrderEvent.PaidPartially]: translate(''),
    [OrderEvent.PaidCompletely]: translate('Order was closed by'),
    [OrderEvent.MovedPartially]: translate(''),
    [OrderEvent.QuickSale]: translate(''),
    [OrderEvent.OrderLinesAdded]: translate(''),
};

export const defineChipColor = (
    theme: DefaultTheme, state: TimelineEvent['eventType']
) => {
    if (state === OrderEvent.OrderLinesAdded) {
        return '#E9E8FF';
    }
    if (state === OrderEvent.CanceledCompletely || state === OrderEvent.CanceledPartially) {
        return '#EC8AB3';
    }
    if (state === OrderEvent.MovedPartially || state === OrderEvent.MovedCompletely) {
        return '#F6C603';
    }
    if (state === OrderEvent.PaidPartially) {
        return '#8EEAC0';
    }
    return '#E9E8FF';
};
